import { Outlet } from 'react-router-dom';

function OnboardingFlow() {
  return <Outlet />;
}

export default OnboardingFlow;
